// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/team.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddTeamMemberRequest, AddTeamMemberResponse, CreateTeamRequest, CreateTeamResponse, DeleteTeamRequest, DeleteTeamResponse, GetTeamRequest, GetTeamResponse, ListTeamMembersRequest, ListTeamMembersResponse, ListTeamsRequest, ListTeamsResponse, RemoveTeamMemberRequest, RemoveTeamMemberResponse, UpdateTeamRequest, UpdateTeamResponse } from "./team_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * TeamService manages teams and team memberships within an organization.
 * A team is an organizational unit that users can belong to.
 * Each user can belong to at most one team per organization.
 *
 * @generated from service gitpod.v1.TeamService
 */
export const TeamService = {
  typeName: "gitpod.v1.TeamService",
  methods: {
    /**
     * Creates a new team within an organization.
     *
     * Use this method to:
     * - Organize users into teams
     * - Set up team-based workflows
     *
     * ### Examples
     *
     * - Create a team:
     *
     *   ```yaml
     *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
     *   name: "Backend Team"
     *   ```
     *
     * ### Authorization
     *
     * Requires `team:create` permission on the organization.
     *
     * @generated from rpc gitpod.v1.TeamService.CreateTeam
     */
    createTeam: {
      name: "CreateTeam",
      I: CreateTeamRequest,
      O: CreateTeamResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets information about a specific team.
     *
     * Use this method to:
     * - Retrieve team details and metadata
     * - View member count
     *
     * ### Examples
     *
     * - Get team details:
     *
     *   ```yaml
     *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * ### Authorization
     *
     * Requires `team:read` permission on the team.
     *
     * @generated from rpc gitpod.v1.TeamService.GetTeam
     */
    getTeam: {
      name: "GetTeam",
      I: GetTeamRequest,
      O: GetTeamResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Lists teams with optional pagination and filtering.
     *
     * Use this method to:
     * - View all teams in an organization
     * - Search for teams by name
     *
     * ### Examples
     *
     * - List all teams:
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * - Search for teams by name:
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 20
     *   filter:
     *     search: "backend"
     *   ```
     *
     * ### Authorization
     *
     * Results are filtered by `team:read` permission.
     *
     * @generated from rpc gitpod.v1.TeamService.ListTeams
     */
    listTeams: {
      name: "ListTeams",
      I: ListTeamsRequest,
      O: ListTeamsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Updates a team's properties.
     *
     * Use this method to:
     * - Rename a team
     *
     * ### Examples
     *
     * - Update team name:
     *
     *   ```yaml
     *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   name: "Platform Team"
     *   ```
     *
     * ### Authorization
     *
     * Requires `team:update` permission on the team.
     *
     * @generated from rpc gitpod.v1.TeamService.UpdateTeam
     */
    updateTeam: {
      name: "UpdateTeam",
      I: UpdateTeamRequest,
      O: UpdateTeamResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a team and all its memberships.
     *
     * Use this method to:
     * - Remove unused teams
     * - Clean up after team reorganization
     *
     * ### Examples
     *
     * - Delete a team:
     *
     *   ```yaml
     *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   ```
     *
     * ### Authorization
     *
     * Requires `team:delete` permission on the team.
     *
     * @generated from rpc gitpod.v1.TeamService.DeleteTeam
     */
    deleteTeam: {
      name: "DeleteTeam",
      I: DeleteTeamRequest,
      O: DeleteTeamResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Adds a user to a team.
     *
     * Each user can belong to at most one team per organization.
     *
     * Use this method to:
     * - Assign users to teams
     *
     * ### Examples
     *
     * - Add a user to a team:
     *
     *   ```yaml
     *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   userId: "f53d2330-3795-4c5d-a1f3-453121af9c60"
     *   ```
     *
     * ### Authorization
     *
     * Requires `teammembership:create` permission on the team.
     *
     * @generated from rpc gitpod.v1.TeamService.AddTeamMember
     */
    addTeamMember: {
      name: "AddTeamMember",
      I: AddTeamMemberRequest,
      O: AddTeamMemberResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Removes a user from a team.
     *
     * Use this method to:
     * - Remove users from teams
     *
     * ### Examples
     *
     * - Remove a team member:
     *
     *   ```yaml
     *   teamMemberId: "a1b2c3d4-5678-90ab-cdef-1234567890ab"
     *   ```
     *
     * ### Authorization
     *
     * Requires `teammembership:delete` permission on the team.
     *
     * @generated from rpc gitpod.v1.TeamService.RemoveTeamMember
     */
    removeTeamMember: {
      name: "RemoveTeamMember",
      I: RemoveTeamMemberRequest,
      O: RemoveTeamMemberResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists members of a team with optional pagination.
     *
     * Use this method to:
     * - View all members of a team
     *
     * ### Examples
     *
     * - List team members:
     *
     *   ```yaml
     *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
     *   pagination:
     *     pageSize: 20
     *   ```
     *
     * ### Authorization
     *
     * Requires `teammembership:read` permission on the team.
     *
     * @generated from rpc gitpod.v1.TeamService.ListTeamMembers
     */
    listTeamMembers: {
      name: "ListTeamMembers",
      I: ListTeamMembersRequest,
      O: ListTeamMembersResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

